import React from "react";
import TriggerInit from "./trigger/trigger_init";
import Router from "./router";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const AppAuth = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <>
      <TriggerInit />
      <Router />
    </>
  );
};
export default AppAuth;
